module.exports = __webpack_public_path__ + "img/video_8.5ced6bc5.png";